webpackJsonp([40],{

/***/ 10:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_libs_common__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_libs_utils_suspension__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_js_libs_utils_topbar_menu__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_config__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_js_libs_utils__ = __webpack_require__(2);
/**
 * Created by lycheng on 2017/12/4.
 * 所有service都需要引入
 */






function bindEvent() {
  // banner下立即申请
  $('.banner-to-service-manage').click(function () {
    var serviceKey = this.dataset.serviceKey;
    Object(__WEBPACK_IMPORTED_MODULE_4_js_libs_utils__["g" /* toUrl */])(__WEBPACK_IMPORTED_MODULE_3_config__["a" /* config */].CONSOLE + 'services/' + serviceKey, '_blank');
  });
  $('.banner-apply-btn').click(function () {
    var $this = $(this);
    var href = Object(__WEBPACK_IMPORTED_MODULE_4_js_libs_utils__["a" /* addCurrentPageParams */])($this.data('href'));
    Object(__WEBPACK_IMPORTED_MODULE_4_js_libs_utils__["g" /* toUrl */])(href, '_blank');
  });
}

function init() {
  Object(__WEBPACK_IMPORTED_MODULE_1_js_libs_utils_suspension__["a" /* suspension */])();
  bindEvent();
}
init();

/***/ }),

/***/ 178:
/***/ (function(module, exports) {

$.extend($.validator.messages, {
  required: "不能为空",
  email: "请输入正确格式的邮箱",
  date: "请输入有效的日期",
  digits: "只能输入数字",
  maxlength: $.validator.format("最多可以输入 {0} 个字符"),
  minlength: $.validator.format("最少要输入 {0} 个字符"),
  rangelength: $.validator.format("请输入长度在 {0} 到 {1} 之间的字符串"),
  range: $.validator.format("请输入范围在 {0} 到 {1} 之间的数值"),
  max: $.validator.format("请输入不大于 {0} 的数值"),
  min: $.validator.format("请输入不小于 {0} 的数值")
});
// 判断XML
$.validator.addMethod('isXSS', function (value, element) {
  return this.optional(element) || !/[<>\/]/.test(value);
}, '不能包含非法字符<>/');

// 判断为纯空格
$.validator.addMethod('isSpace', function (value, element) {
  var regu = /^[\s　]|[ ]$/gi;
  return this.optional(element) || !regu.test(value);
}, '首尾不能有空格');

//判断手机号码
$.validator.addMethod("isMobile", function (value, element) {
  var length = value.length;
  var mobile = /^(1[0-9][0-9]{9})$/;
  return this.optional(element) || length == 11 && mobile.test(value);
}, '请正确填写您的手机号码');

/***/ }),

/***/ 4:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./src/js/api/user.js
var user = __webpack_require__(3);

// EXTERNAL MODULE: ./src/js/libs/utils.js
var utils = __webpack_require__(2);

// EXTERNAL MODULE: ./src/js/config/prod.js
var prod = __webpack_require__(0);

// EXTERNAL MODULE: ./src/scss/component/announcement.scss
var announcement = __webpack_require__(5);
var announcement_default = /*#__PURE__*/__webpack_require__.n(announcement);

// EXTERNAL MODULE: ./src/js/libs/utils-cookie.js
var utils_cookie = __webpack_require__(6);

// CONCATENATED MODULE: ./src/js/libs/utils-announcement.js
/**
 * 公告
 */


var _countDown = null;
var ancmtModel = {
  addEvent: function addEvent() {
    $('.ancmt-detail').on('click', '.ancmt-bullet-box-close-btn', function () {
      $('.ancmt-wrap').hide();
    });
    $('body').not('.ancmt-wrap').bind('click', function () {
      $('.ancmt-wrap').hide();
    });
  },
  countDown: function countDown() {
    var allTime = 15;
    _countDown = setInterval(function () {
      $('#abb_num').text(--allTime);
      if (allTime < 0) {
        $('.ancmt-wrap').hide();
        clearInterval(_countDown);
      }
    }, 1000);
  },
  fireAction: function fireAction() {
    $('#open_announcement').bind('click', function (e) {
      e.stopPropagation();
      $('.ancmt-wrap').show();
    });
  },
  showTop: function showTop() {
    if (!utils_cookie["a" /* cookie */].get('top_banner_closed')) {
      $('#top_banner_wrap').show();
    }
  },
  bindTopAction: function bindTopAction() {
    $('#close_banner_top').bind('click', function () {
      $('#top_banner_wrap').hide();
      var curDate = new Date();
      var curTamp = curDate.getTime();
      var curWeeHours = new Date(curDate.toLocaleDateString()).getTime() - 1;
      var passedTamp = curTamp - curWeeHours;
      var leftTamp = 24 * 60 * 60 * 1000 - passedTamp;
      var leftTime = new Date();
      leftTime.setTime(leftTamp + curTamp);
      utils_cookie["a" /* cookie */].pureSet('top_banner_closed', true, leftTime.toGMTString() + ';path=/');
    });
  },
  init: function init() {
    var that = this;
    that.addEvent();
    that.fireAction();
    that.showTop();
    that.bindTopAction();
    // that.countDown()
  }
};
ancmtModel.init();
// CONCATENATED MODULE: ./src/js/libs/utils-suspension.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return suspension; });
/**
 * Created by lycheng on 2017/11/29.
 * 悬浮的狗，返回顶部
 */





function initZcScript(w, d, e, x) {
  w[e] = function () {
    w.cbk = w.cbk || [];
    w.cbk.push(arguments);
  };
  x = d.createElement("script");
  x.async = true;
  x.id = "zhichiScript";
  x.className = "im-btn";
  x.src = "https://chat.sobot.com/chat/frame/v2/entrance.js?sysnum=1f851a5acb6e4f408a3e3e5487750951";
  d.body.appendChild(x);
}

function initZc(userInfo) {
  var nick = userInfo.nickname;
  var nickLogin = userInfo.login;
  var nickMiddle = nickLogin.length / 2;
  var isEven = nickLogin.length % 2 === 0;
  var nickEncry = isEven ? nickMiddle : Math.ceil(nickMiddle) - 2;
  nickLogin = nickLogin.length > 5 ? nickLogin.replace(nickLogin.substring(nickEncry, nickEncry + 2), "***") : nickLogin;
  user["a" /* aesEncry */](userInfo.uid).then(function (r) {
    var uid = r.data;
    var isZcBack = window.location.search.includes("isZc=1");
    initZcScript(window, document, "zc");
    var args = {
      customField7: uid
    };
    var prms = {
      uid: uid
    };
    zc("config", {
      uname: nick || nickLogin,
      custom: true, // 设置自定义
      color: "2277e6",
      customer_fields: JSON.stringify(args),
      params: JSON.stringify(prms),
      partnerid: uid,
      auto_expand: isZcBack
    });
    zc("dynamic_ready");
  });
}
/**
 * 右侧悬浮
 * @param s:距离顶部的高度
 */
function suspension() {
  var $suspension = $(".affix");
  var $backTop = $(".affix-bottom");
  var $panelSuggest = $(".affix-panel-content__suggest");
  var $panelApplet = $(".affix-panel-content__applet");
  var $panelAdvice = $(".affix-panel-content__advice");
  var $iframe = $(".affix-panel-content__iframe");
  var timer = null;
  $(window).scroll(function () {
    var scrollTop = $(window).scrollTop();
    if (scrollTop < 204) {
      $suspension.removeClass("affix_fixed");
    } else {
      $suspension.addClass("affix_fixed");
    }
    if (scrollTop > 204) {
      $backTop.show();
    } else {
      $backTop.hide();
    }
  });
  $backTop.click(function () {
    $("body, html").animate({ scrollTop: 0 }, 500);
    return false;
  });

  $(".affix-advice").click(function () {
    clearTimeout(timer);
    user["e" /* getUserinfo */]().then(function (res) {
      if (res.code === 80000) {
        var jumpBack = typeof window !== "undefined" ? Base64.encode(window.location.href) : "";
        window.location.href = prod["a" /* config */].PASSPORT_NEW + "/login?jump=" + jumpBack;
      } else {
        $panelAdvice.removeClass("show");
        $panelAdvice.addClass("show");
        $iframe[0].contentWindow.postMessage({ type: 'showBotChat' }, '*');
      }
    });
  });
  $(".affix-suggest").mouseenter(function () {
    clearTimeout(timer);
    $panelApplet.removeClass("show");
    $panelSuggest.addClass("show");
  });
  $(".affix-suggest").mouseleave(function () {
    timer = setTimeout(function () {
      $panelSuggest.removeClass("show");
      clearTimeout(timer);
    }, 500);
  });
  $panelSuggest.mouseenter(function () {
    clearTimeout(timer);
    $panelSuggest.addClass("show");
  });
  $panelSuggest.mouseleave(function () {
    timer = setTimeout(function () {
      $panelSuggest.removeClass("show");
      clearTimeout(timer);
    }, 500);
  });
  $(".affix-applet").mouseenter(function () {
    $panelSuggest.removeClass("show");
    $panelApplet.addClass("show");
  });
  $(".affix-applet").mouseleave(function () {
    $panelApplet.removeClass("show");
  });

  function checkImLog() {
    user["e" /* getUserinfo */]().then(function (result) {
      if (result.code === 80000) {
        $(".im-icon").removeClass("im-btn");
        $(".im-icon").click(function () {
          var jumpBack = typeof window !== "undefined" ? Base64.encode(Object(utils["e" /* setQueryString */])("isZc", 1)) : "";
          window.location.href = prod["a" /* config */].PASSPORT + "/login?jump=" + jumpBack;
        });
      } else {
        initZc(result.data);
      }
    });
  }

  // checkImLog();
}

var methods = {
  setIframe: function setIframe(w, h) {
    $(".affix-panel-content__iframe").width(w).height(h);
  }
};
$(function () {
  window.addEventListener("message", function (e) {
    if (e.data.type === 'dom') {
      var data = e.data.data;

      var width = data.width;
      var height = data.height + 12;
      methods.setIframe(width, height);
    }
    if (e.data.type === 'close') {
      $(".affix-panel-content__advice").removeClass('show');
    }
  });
});


/***/ }),

/***/ 5:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 881:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_scss_solutions_xfyeta_scss__ = __webpack_require__(882);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_scss_solutions_xfyeta_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_scss_solutions_xfyeta_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_polyfill__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_js_libs_utils_solutions__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_js_libs_utils_layer__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_js_libs_jquery_validate_jquery_validate_config__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_js_libs_jquery_validate_jquery_validate_config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_js_libs_jquery_validate_jquery_validate_config__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_config__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_js_libs_gt__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_js_libs_gt___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_js_libs_gt__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_js_base64__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_js_base64___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_js_base64__);




// import 'js/libs/jquery.validate/jquery.validate.min'





var type = 1;
// 弹框效果
var alertTitle = [{
  title: '宽带到期提醒功能体验'
}, {
  title: '话费低余额提醒功能体验'
}, {
  title: '汽车4S店满意度回访功能体验'
}, {
  title: '会议邀约功能体验'
}];

var SubmitModel = {
  timer: null, // 定义一个定时器；
  geetestApi: function geetestApi() {
    var that = this;
    $.ajax({
      url: '/herapi/plug/geetestInit',
      type: 'get',
      dataType: 'json',
      success: function success(data) {
        // 调用 initGeetest 进行初始化
        // 参数1：配置参数
        // 参数2：回调，回调的第一个参数验证码对象，之后可以使用它调用相应的接口
        initGeetest({
          // 以下 4 个配置参数为必须，不能缺少
          gt: data.data.gt,
          challenge: data.data.challenge,
          offline: !data.data.success, // 表示用户后台检测极验服务器是否宕机
          new_captcha: data.data.new_captcha, // 用于宕机时表示是新验证码的宕机
          product: 'bind', // 产品形式，包括：float，popup
          width: '300px'
          // 更多配置参数说明请参见：http://docs.geetest.com/install/client/web-front/
        }, function (captchaObj) {
          captchaObj.onReady(function () {}).onSuccess(function () {
            that.result = captchaObj.getValidate();
            if (!that.result) {
              return alert('请完成验证');
            }
            // 获取验证码
            that.eventList.getCode(that.result);
          });
          $('#confirm').click(function () {
            $('#xfyeta-apply-form').validate().element($('#xfyetatel'));
            if ($('#error_tip').text() === '') {
              captchaObj.verify();
            }
          });
        });
      }
    });
  },
  getCodeInterval: function getCodeInterval() {
    var that = this;
    var $btn = $('#confirm');
    var $timeInterval = $('.time-interval');
    var time = 60; // 定义时间变量。用于倒计时用
    $btn.hide(); // 将按钮隐藏
    $timeInterval.show().text(time + '秒后重发');
    that.timer = setInterval(function () {
      // 开启定时器。函数内执行
      time--; // 时间值自减
      if (time === 0) {
        // 判断,当时间值小于等于0的时候
        $btn.show();
        $timeInterval.hide();
        clearInterval(that.timer); // 清除定时器
        $timeInterval.text('');
      }
      $timeInterval.text(time + '秒后重发'); // 点击发生后，文本内容变成之前定义好的时间值。
    }, 1000);
  },
  eventList: {
    getCode: function getCode(geeRes) {
      var that = SubmitModel; // 调用后端接口，然后判断验证码是否获取成功，成功显示倒计时，不成功给个提示按扭不动
      var parames = {
        mobile: $('input[name="xfyetatel"]').val(),
        geetest_challenge: geeRes.geetest_challenge,
        geetest_validate: geeRes.geetest_validate,
        geetest_seccode: geeRes.geetest_seccode
      };
      $.ajax({
        url: '/herapi/plug/mobilecode/get',
        type: 'POST',
        dataType: 'json',
        data: parames,
        success: function success(result) {
          if (result.flag) {
            that.getCodeInterval();
          } else {
            if (result.code !== 0) {
              var error = result.desc;
              $('#error_tip').text(error);
            }
          }
        }
      });
    },
    ajaxSend: function ajaxSend(parames) {
      $.ajax({
        url: '/herapi/product/addLongTermTaskData',
        type: 'POST',
        dataType: 'json',
        data: parames,
        success: function success(result) {
          if (result.flag) {
            __WEBPACK_IMPORTED_MODULE_3_js_libs_utils_layer__["a" /* layer */].close('.modalContainer');
            $('#call-pop-mask').css('display', 'block');
            $('.experienceDialog').css('display', 'block');
          } else {
            if (result.code !== 0) {
              var error = result.desc;
              $('#error_tip').text(error);
            }
          }
        }
      });
    },
    submit: function submit() {
      var that = SubmitModel;
      var parames = {};
      switch (type) {
        case 1:
          parames = {
            geetest_challenge: that.result.geetest_challenge,
            geetest_validate: that.result.geetest_validate,
            geetest_seccode: that.result.geetest_seccode ? __WEBPACK_IMPORTED_MODULE_7_js_base64__["Base64"].encode(that.result.geetest_seccode) : '',
            robotId: 20001571,
            mobile: $('input[name="xfyetatel"]').val(),
            code: $('input[name="yanzhengma"]').val()
          };
          break;
        case 2:
          parames = {
            geetest_challenge: that.result.geetest_challenge,
            geetest_validate: that.result.geetest_validate,
            geetest_seccode: that.result.geetest_seccode ? __WEBPACK_IMPORTED_MODULE_7_js_base64__["Base64"].encode(that.result.geetest_seccode) : '',
            robotId: 20001572,
            mobile: $('input[name="xfyetatel"]').val(),
            code: $('input[name="yanzhengma"]').val()
          };
          break;
        case 3:
          parames = {
            geetest_challenge: that.result.geetest_challenge,
            geetest_validate: that.result.geetest_validate,
            geetest_seccode: that.result.geetest_seccode ? __WEBPACK_IMPORTED_MODULE_7_js_base64__["Base64"].encode(that.result.geetest_seccode) : '',
            robotId: 20001570,
            mobile: $('input[name="xfyetatel"]').val(),
            code: $('input[name="yanzhengma"]').val()
          };
          break;
        case 4:
          parames = {
            geetest_challenge: that.result.geetest_challenge,
            geetest_validate: that.result.geetest_validate,
            geetest_seccode: that.result.geetest_seccode ? __WEBPACK_IMPORTED_MODULE_7_js_base64__["Base64"].encode(that.result.geetest_seccode) : '',
            robotId: 20001723,
            mobile: $('input[name="xfyetatel"]').val(),
            code: $('input[name="yanzhengma"]').val()
          };
          break;
      }
      that.eventList.ajaxSend(parames);
    }
  },
  addEvent: function addEvent() {
    var that = this;
    $(document).on('click', '#taste_button', function () {
      // 获取当前选择的类型
      type = Number($('#dialect_select').val());
      $('#confirm').show();
      $('.time-interval').css('display', 'none');
      clearInterval(SubmitModel.timer); // 清除定时器
      __WEBPACK_IMPORTED_MODULE_3_js_libs_utils_layer__["a" /* layer */].open('.modalContainer');
      $('.form-item-error').text('');
      $(':text').val('');
      $('.alert-title').html(alertTitle[type - 1].title);
    });
    $('.closeBtn').click(function () {
      $('#call-pop-mask').css('display', 'none');
      $('.experienceDialog').css('display', 'none');
      $('#confirm').show();
      $('.time-interval').css('display', 'inline-block');
      clearInterval(SubmitModel.timer); // 清除定时器
    });
    $('.icons-icons-close').click(function () {
      $('#confirm').show();
      $('.time-interval').css('display', 'none');
      clearInterval(SubmitModel.timer); // 清除定时器
    });
    // 验证表单事件
    $('#xfyeta-apply-form').validate({
      onfocusout: false,
      onkeyup: false,
      errorPlacement: function errorPlacement(error, element) {
        error.appendTo('.form-item-error');
      },
      showErrors: function showErrors(errorMap, errorList) {
        if (errorList.length !== 0) {
          $('#error_tip').empty().text(errorList[0].message);
        } else {
          $('#error_tip').empty();
        }
      },
      submitHandler: function submitHandler() {
        that.eventList.submit();
      },
      rules: {
        xfyetatel: {
          required: true,
          isMobile: true
        },
        yanzhengma: {
          required: true
        }
      },
      messages: {
        xfyetatel: {
          required: '请输入手机号',
          isMobile: '手机号格式错误，请重新输入'
        },
        yanzhengma: {
          required: '请输入验证码'
        }
      }
    });
  },
  init: function init() {
    var that = this;
    that.addEvent();
    that.geetestApi();
  }
};

$(function () {
  SubmitModel.init();
});

/***/ }),

/***/ 882:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 9:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export floatMenu */
/**
 * Created by lycheng on 2017/12/4.
 * 右边导航
 */

// 右边导航
var floatMenu = {
  config: {
    top: 90,
    difference: 5, // 为了避免top与tops临界点差值过小时，animate不触发的问题
    $container: $('html,body'),
    checkedClass: 'nav-checked'
  },
  init: function init() {
    floatMenu.bindEvent();
    floatMenu.methods.rePosition();
  },
  bindEvent: function bindEvent() {
    $('.js-custom-nav-fall li').off('click').on('click', function () {
      var target = $(this).attr('target');
      floatMenu.methods.toPosition(target);
    });
    window.onscroll = function () {
      floatMenu.methods.rePosition();
    };
  },
  methods: {
    toPosition: function toPosition(target) {
      var top = $('.' + target).offset().top - floatMenu.config.top + floatMenu.config.difference;
      floatMenu.config.$container.animate({ scrollTop: Math.floor(top) }, 500);
    },
    rePosition: function rePosition() {
      var tops = [];
      var top = $('body').scrollTop() || $('html').scrollTop();
      var $navCon = $('.js-custom-nav-fall');
      var $navItem = $('.js-custom-nav-fall li');
      var targets = [];
      var i = 0;
      $navItem.each(function () {
        targets.push($(this).attr('target'));
      });

      for (i = 0; i < targets.length; i++) {
        if ($('.' + targets[i]).offset()) {
          tops.push(Math.floor($('.' + targets[i]).offset().top) - floatMenu.config.top);
        }
      }
      tops.push(tops[i - 1] + $('.' + targets[i - 1]).height());

      for (i = 0; i < targets.length; i++) {
        if (top >= tops[i]) {
          $navItem.removeClass(floatMenu.config.checkedClass);
          $navItem.filter('[target="' + targets[i] + '"]').addClass(floatMenu.config.checkedClass);
        }
      }
      var windowPosition = $(window).scrollTop();
      if (windowPosition >= 300) {
        $navCon.show();
      } else {
        $navCon.hide();
      }
    }

  }
};
floatMenu.init();


/***/ })

},[881]);


// WEBPACK FOOTER //
// js/solutions/xfyeta.9829e1fb1ec088e08237.bundle.js